document.addEventListener("DOMContentLoaded", function () {
    // Select all collapsible items
    const collapsibleItems = document.querySelectorAll(".collapsible-content__item");

    // Loop through each item and remove the "active" class
    collapsibleItems.forEach(function (item) {
        item.classList.remove("active");

        // Ensure the content inside is hidden
        const answer = item.querySelector(".collapsible-content__answer");
        if (answer) {
            answer.style.display = "none";
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".custom-collapsible-toggle").forEach(function(toggle) {
    toggle.addEventListener("click", function() {
      let parent = this.parentElement;
      let isOpen = parent.classList.contains("open");

      // Close all other items before opening a new one
      document.querySelectorAll(".custom-collapsible-item").forEach(function(item) {
        item.classList.remove("open");
      });

      // Toggle the clicked one
      if (!isOpen) {
        parent.classList.add("open");
      }
    });
  });
});

